import React from 'react';
import PropTypes from 'prop-types';
import { TableCellWithOverflow } from 'components/list/TableComponentsStyled';
import { Tooltip } from '@mui/material';

const TextTableCell = ({ content, children, sx }) => {
  return (
    <TableCellWithOverflow sx={sx}>
      <Tooltip title={content} placement='bottom-start'>
        {children || content}
      </Tooltip>
    </TableCellWithOverflow>
  );
};

TextTableCell.propTypes = {
  content: PropTypes.string,
  children: PropTypes.node,
  sx: PropTypes.object
};

export default TextTableCell;
